<template>
    <div class="page">
        <box fill>
            <el-form label-position="right" label-width="80px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="工单编号" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.opCode">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料编号" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.matCode">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料名称" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.matName">
                        </el-input>
                    </el-form-item>
                </el-col>
                 <el-col :lg="5" :xl="5">
                    <el-form-item label="通道" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.whCode">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getOrderProductBomData()">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete" @click="resetData()">
                            重置
                        </el-button>
                    </el-form-item>
                </el-col>
            </el-form>
            <el-divider></el-divider>
            <plabel text="工单原材料">
                <el-button :loading="!loading" v-authority="'BACK_MENU5_M15_B1'" class="btn-t-edit" @click="(add_or_edit = true), (editBoxShow = true)">新增</el-button>
                <el-button :loading="!loading" v-authority="'BACK_MENU5_M15_B4'" class="btn-t-edit" @click="downLoadFile()">导出EXCEL</el-button>
            </plabel>
            <!-- 展示 -->
            <h-table v-loading="!loading" :headerCellStyle="headerCellStyle" style="flex: 1" @pageChange="getOrderProductBomData" :data="mainData" pagination :nowPage.sync="pagination.pageNum" :pageSize.sync="pagination.pageSize" :total.sync="tableTotal">
                <el-table-column prop="opCode" label="工单编号" />
                <el-table-column prop="matCode" label="物料编号" />
                <el-table-column prop="matName" label="物料名称" />
                <el-table-column prop="matQuan" label="工单数量" />
                <el-table-column prop="whCode" label="通道" />
                <el-table-column prop="createTime" label="工单同步时间" />
                <el-table-column prop="matCallQuan" label="已叫料数量" />
                <el-table-column prop="remark" label="备注" />
                <el-table-column label="操作" width="150">
                     <template slot-scope="scope">
                        <el-button v-authority="'BACK_MENU5_M15_B2'" :disabled="scope.row.mtXa ? true : false" size="mini" type="primary" @click="
                (add_or_edit = false),
                  (editBoxShow = true),
                  (mainObj = JSON.parse(JSON.stringify(scope.row)))
              " plain icon="el-icon-edit-outline" />
                        <el-button v-authority="'BACK_MENU5_M15_B3'" type="danger" @click="deleteRow(scope.row.opId)" size="mini" plain icon="el-icon-delete" />
                    </template>
                </el-table-column>
            </h-table>
        </box>
        <!-- 新增&&编辑框 -->
            <el-dialog :title="add_or_edit ? '新增' : '编辑'" :close-on-click-modal="false" :visible.sync="editBoxShow" :model="mainObj" @open="open" :style="$popups.popups(0.5,0.6)" class="fromDialog">
                <span class="formClass">
                    <el-form :inline="true" label-position="top" label-width="80px" :model="mainObj" :rules="rules" ref="mainObj">
                        <el-col :lg="8" :xl="8">
                            <el-form-item label="工单编号" prop="opCode" class="EL-Form-Item">
                                <el-input v-model.trim="mainObj.opCode" maxlength="20"> </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="8" :xl="8">
                            <el-form-item label="物料编号" prop="matCode" class="EL-Form-Item">
                                <el-input v-model.trim="mainObj.matCode" maxlength="20"> </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="8" :xl="8">
                            <el-form-item label="物料名称" prop="matName" class="EL-Form-Item">
                                <el-input v-model.trim="mainObj.matName" maxlength="50"> </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="8" :xl="8">
                            <el-form-item label="工单数量" prop="matQuan" class="EL-Form-Item">
                                <el-input-number v-model="mainObj.matQuan" :min="1"></el-input-number>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="8" :xl="8">
                            <el-form-item label="通道" prop="whCode" class="EL-Form-Item">
                                <el-input v-model="mainObj.whCode" maxlength="5"> </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="8" :xl="8">
                            <el-form-item label="已叫料数量" prop="matCallQuan" class="EL-Form-Item">
                                <el-input-number v-model="mainObj.matCallQuan" :min="1"></el-input-number>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="8" :xl="8">
                            <el-form-item label="备注" prop="remark" class="EL-Form-Item">
                                <el-input v-model="mainObj.remark"> </el-input>
                            </el-form-item>
                        </el-col>
                    </el-form>
                </span>
                <span slot="footer" class="dialog-footer footer-bottom">
                    <el-button size="small" type="info" @click="editBoxShow = false">
                        取 消
                    </el-button>
                    <el-button size="small" type="primary" v-if="add_or_edit" @click="add">
                        新 增
                    </el-button>
                    <el-button size="small" type="primary" v-else @click="editRow">
                        修 改
                    </el-button>
                </span>
            </el-dialog>
    </div>
</template>

<script>
export default {
    name: "OrderProductBom",
    data() {
        return {
            headerCellStyle: () => {
                return "background-color: #1f5cec";
            },
            form: {},

            showRoleBox: true,
            add_or_edit: Boolean, //新增|编辑
            editBoxShow: false, //编辑框
            dialogFormVisible: false,
            formLabelWidth: "140px", // 对话框大小
            tableHeight: 0, //表格高度
            testValue: 1,
            mainObj: {},
            pagination: {
                pageSize: 50,
                pageNum: 1,
                opCode: "",
                matCode: "",
                matName: "",
                whCode: "",
                closeFlag: false,
            },
            tableTotal:0,
            mainData: [],
            fcode: localStorage.getItem("fcCode") || "",

            downloadLoading: false, //下载中

            loading: 0,

            logContent: "", //操作日志-内容
            logRemarks: "", //操作日志-备注
            // 输入框延时加载
            isSetTimeout: null,

            rules: {
                opCode: [{
                    required: true,
                    message: "请输入",
                    trigger: "blur",
                }, ],
                matCode: [{
                    required: true,
                    message: "请输入",
                    trigger: "blur",
                }, ],
                matName: [{
                    required: true,
                    message: "请输入",
                    trigger: "blur",
                }, ],
                matQuan: [{
                    required: true,
                    message: "请输入",
                    trigger: "blur",
                }, ],
                whCode: [{
                    required: true,
                    message: "请输入",
                    trigger: "blur",
                }, ],
                matCallQuan: [{
                    required: true,
                    message: "请输入",
                    trigger: "blur",
                }, ],
                // mtType: [{
                //     required: true,
                //     message: "请输入",
                //     trigger: "blur",
                // }, ],
                // validityMonth: [{
                //     required: true,
                //     message: "请输入",
                //     trigger: "blur",
                // }, ],
            },

            showRoleBox: true,
            add_or_edit: Boolean, //新增|编辑
            editBoxShow: false, //编辑框
            dialogFormVisible: false,
            formLabelWidth: "140px", // 对话框大小
            tableHeight: 0, //表格高度
            testValue: 1,
        };
    },
    watch: {
        pagination: {
            handler(newVal) {
                clearTimeout(this.isSetTimeout)
                this.isSetTimeout = setTimeout(() => {
                    this.getOrderProductBomData(newVal);
                }, 1000)
            },
            deep: true,
        },
    },
    methods: {
        //获取数据
        getOrderProductBomData() {
          this.loading++
          var paramsObj = {
            pageSize: this.pagination.pageSize,
            pageNum: this.pagination.pageNum,
            opCode: this.pagination.opCode,
            matCode: this.pagination.matCode,
            matName: this.pagination.matName,
            whCode: this.pagination.whCode,
            // closeFlag: this.pagination.closeFlag,
          }
            this.$http
                .request({
                    url: "/api/orderProduct/getOrderProductBomData",
                    method: "GET",
                    params: paramsObj,
                })
                .then((resp) => {
                    if (resp.status == 100) {
                        this.mainData = resp.data.list || [];
                        this.tableTotal = resp.data.total;
                    }
                })
                .catch((error) => {

                });
        },
        //表单验证
        submitForm(formName) {
            let r = Boolean;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    r = true;
                } else {
                    r = false;
                }
            });
            return r;
        },
        //框打开
        open() {
            if (this.add_or_edit) {
                //新增
                this.mainObj = JSON.parse(JSON.stringify({}));
            } else {
                this.getOrderProductBomData();
            }
        },
        //新增
        add() {
            if (this.fcode != "") {
                this.mainObj.fcCode = this.fcode;
            }
            if (this.submitForm("mainObj")) {
                this.$http
                    .request({
                        url: "/api/orderProduct/insertOrderProductBomData",
                        method: "POST",
                        showLoading: true,
                        data: this.mainObj,
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.$notify({
                                title: "成功",
                                message: "新增成功！",
                                type: "success",
                            });
                            this.logRemarks = "material：工单原材料新增成功";
                        } else {
                            this.$notify.error({
                                title: "失败",
                                message: resp.message,
                            });
                            this.logRemarks = "material：工单原材料新增失败";
                        }
                        this.logContent =
                            "mtCode：" +
                            this.mainObj.mtCode +
                            "\t mtName" +
                            this.mainObj.mtName;
                        this.systemLog();
                        this.editBoxShow = false;
                        this.getOrderProductBomData();
                    })
                    .catch((error) => {
                        this.$notify.error({
                            title: "失败",
                            message: "调用失败",
                        });
                    });
            }
        },
        //编辑
        editRow() {
            if (this.submitForm("mainObj")) {
                this.$http
                    .request({
                        url: "/api/orderProduct/updateOrderProductBomData",
                        method: "POST",
                        showLoading: true,
                        data: this.mainObj,
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.$notify({
                                title: "成功",
                                message: "修改成功！",
                                type: "success",
                            });
                            this.logRemarks = "material：工单原材料编辑成功";
                        } else {
                            this.$notify.error({
                                title: "失败",
                                message: resp.message,
                            });
                            this.logRemarks = "material：工单原材料编辑失败";
                        }
                        this.logContent =
                            "mtCode：" +
                            this.mainObj.mtCode +
                            "\t mtName" +
                            this.mainObj.mtName;
                        this.systemLog();
                        this.editBoxShow = false;
                        this.getOrderProductBomData();
                    })
                    .catch((error) => {
                        this.$notify.error({
                            title: "失败",
                            message: "调用失败",
                        });
                    });
            }
        },
        //删除
        deleteRow(opId) {
            this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
                confirmButtonText: "删除",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$http
                        .request({
                            url: "/api/orderProduct/deleteOrderProductBomData",
                            method: "DELETE",
                            showLoading: true,
                            params: {
                                opId: opId,
                            },
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                this.$notify({
                                    title: "成功",
                                    message: "删除成功！",
                                    type: "success",
                                });
                                this.logRemarks = "material：工单原材料删除成功";
                            } else {
                                this.$notify.error({
                                    title: "失败",
                                    message: "删除失败",
                                });
                                this.logRemarks = "material：工单原材料删除失败";
                            }
                            this.logContent = "opId" + opId;
                            this.systemLog();
                            this.getOrderProductBomData();
                        })
                        .catch((error) => {
                            this.$notify.error({
                                title: "失败",
                                message: "调用失败",
                            });
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },

        //重置
        resetData() {
            this.pagination = {
                pageSize: 50,
                pageNum: 1,
                mtCode: "",
                mtName: "",
                fcCode: localStorage.getItem("fcCode"),
            };
            this.tableTotal=0;
            // this.getOrderProductBomData();
        },

        //表格导出
        downLoadFile() {
            this.downloadLoading = true;
            var paramsObj = {
                matCode: this.pagination.matCode,
                matName: this.pagination.matName,
                opCode: this.pagination.opCode,
                whCode: this.pagination.whCode,
                pageNum: 1,
                pageSize: 999999,
            }

            this.$http.request({
                url: '/api/orderProduct/getOrderProductBomData',
                method: 'GET',
                showLoading: true,
                params: paramsObj
            }).then((resp) => {
                resp.status == 100 ? this.downLoad(resp.data.list || []) : this.$notify.error({
                    message: '查询失败'
                });
            })
        },
        downLoad(list) {
            import('@/libs/Export2Excel').then(excel => {
                list.forEach(function(c) {
                    if (c.mtCheck == '10') {
                        c['mtCheck'] = '全检'
                    } else if (c.mtCheck == '20') {
                        c['mtCheck'] = '免检'
                    } else if (c.mtCheck == '30') {
                        c['mtCheck'] = '抽检'
                    }

                    if (c.mtXa == true) {
                        c['mtXa'] = '是'
                    } else if (c.mtXa == false) {
                        c['mtXa'] = '否'
                    }
                })
                const tHeader = ['工单编号','物料编号', '物料描述', '工单数量', '通道', '工单同步时间', '已叫料数量', '备注']
                const filterVal = ['opCode','matCode', 'matName', 'matQuan', 'whCode', 'createTime', 'matCallQuan', 'remark']
                const data = this.formatJson(filterVal, list)
                excel.export_json_to_excel({
                    header: tHeader,
                    data,
                    filename: '工单原材料主数据'
                })
                this.logContent = "导出"
                this.logRemarks = "sys_material：导出工单原材料主数据"
                this.systemLog();
                this.downloadLoading = false
            })
        },
        formatJson(filterVal, jsonData) {
            return jsonData.map(v => filterVal.map(j => v[j]))
        },


        /**
         * 操作日志
         */
        systemLog() {
            let objData = {
                logType: "物料主数据",
                logContent: this.logRemarks || "",
                //logRemarks: this.logRemarks || "",
                logUser: localStorage.getItem("user") || "",
            };
            this.$http
                .request({
                    url: "api/log/insert",
                    method: "POST",
                    data: objData,
                })
                .then((resp) => {
                    this.logContent = "";
                    this.logRemarks = "";
                    if (resp.status == 100) {}
                })
                .catch((error) => {});
        },
    },
    activated() {
        /* 获取首页的数据 */
        this.getOrderProductBomData();
    },
};
</script>

<style scoped>
</style>